<mat-card
  *ngIf="!expandable; else expandableTemplate"
  [class.error]="showErrorBar"
  [class.pristine]="showPristineBar"
  [class.valid]="showValidBar"
>
  <div class="progress-top" [style.width.%]="percentageCompletion || 100"></div>
  <mat-card-title>
    <ng-container *ngTemplateOutlet="contentHeader"></ng-container>
  </mat-card-title>
  <mat-card-content>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </mat-card-content>
</mat-card>

<ng-template #expandableTemplate>
  <mat-expansion-panel
    [expanded]="expanded"
    [class.valid]="showValidBar"
    [class.error]="showErrorBar"
    [class.pristine]="showPristineBar"
  >
    <mat-expansion-panel-header>
      <div
        class="progress-top"
        [style.width.%]="percentageCompletion || 100"
      ></div>
      <mat-panel-title>
        <ng-container *ngTemplateOutlet="contentHeader"></ng-container>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </mat-expansion-panel>
</ng-template>

<ng-template #contentHeader>
  <ng-content select="wz-form-group-header"></ng-content>
</ng-template>

<ng-template #content>
  <div style="position: relative">
    <div *ngIf="disabled" class="overlay"></div>
    <div [class.readonly]="disabled" class="content" #contentEl>
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
